import { jsx as _jsx } from "react/jsx-runtime";
import { memo } from "react";
import { FilterRowWithCheckbox } from "~/components/Filters/FilterRowWithCheckbox";
const ORIENTATION_OPTIONS = [
    {
        label: "Portrait",
        value: "portrait"
    },
    {
        label: "Landscape",
        value: "landscape"
    },
    {
        label: "Square",
        value: "square"
    }
];
export const OrientationFilter = /*#__PURE__*/ memo((param)=>{
    let { selectedValues, onSelectionChange } = param;
    const handleOrientationToggle = (value, isSelected)=>{
        if (isSelected) {
            onSelectionChange([
                ...selectedValues,
                value
            ]);
        } else {
            onSelectionChange(selectedValues.filter((v)=>v !== value));
        }
    };
    return /*#__PURE__*/ _jsx("div", {
        children: ORIENTATION_OPTIONS.map((option)=>/*#__PURE__*/ _jsx(FilterRowWithCheckbox, {
                label: option.label,
                isSelected: selectedValues.includes(option.value),
                onChange: (isSelected)=>handleOrientationToggle(option.value, isSelected)
            }, option.value))
    });
});
OrientationFilter.displayName = "OrientationFilter";
